export class TroubleSignupDTO {
    fullName: string;
    email: string;
    phone: string;
    issue: string;

    constructor() {
        this.fullName = '';
        this.email = '';
        this.phone = '';
        this.issue = '';
    }
}
